import type { CtasModel, CtasType } from '@Types/Shared/Button';

import { Button } from '@Shared/Button/Button';

export const Buttons = ({
	buttons,
	className = '',
	primaryClassname = '',
	secondaryClassname = '',
	tertiaryClassname = '',
	ctasStyle,
}: {
	buttons: CtasType[];
	className?: string | undefined;
	primaryClassname?: string;
	secondaryClassname?: string;
	tertiaryClassname?: string;
	ctasStyle?: CtasModel;
}) => {
	return (
		<>
			{buttons && (
				<div className={`mt-5 flex flex-wrap items-center gap-4 tablet:mt-7 tablet:gap-6 ${className}`}>
					{buttons.map((btn) => {
						return (
							<Button
								key={btn.id}
								label={btn.label}
								className={'rounded-md bg-black px-8 py-4 text-white'}
								style={btn.style}
								url={btn.link.url}
								urlType={btn.link.type}
								urlTitle={btn.link.title}
								urlOpenNewTab={btn.link.opensInNewTab}
								btnHasIcon={ctasStyle && ctasStyle[btn.style]?.btnHasIcon}
								btnDecorationElement={ctasStyle && ctasStyle[btn.style]?.btnDecorationElement}
								animation={ctasStyle && ctasStyle[btn.style]?.animation}
								primaryClassname={primaryClassname}
								secondaryClassname={secondaryClassname}
								tertiaryClassname={tertiaryClassname}
							/>
						);
					})}
				</div>
			)}
		</>
	);
};
